// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    IEntlibResponseNoData,
    MainPracticeRequestModel,
    PatientsSearchRequestModel,
    PrescriberRequestModel,
    PrescribersByTenantRequestModel,
    SitesAndPrescribersByTenantRequestModel,
    SitesByTenantRequestModel,
    TenantHealthCarePracticePortalCreateMainPracticeResponse,
    TenantHealthCarePracticePortalGetMainPracticeResponse,
    TenantHealthCarePracticePortalGetPrescribersByPracticeIdResponse,
    TenantHealthCarePracticePortalGetSitesByMainPracticeIdResponse,
    TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest,
    TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest,
    TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse,
    TenantHealthCarePracticePortalSiteRequestModel,
    TenantPrescriberObject,
    TenantSiteAndPrescriberObject,
    TenantSiteObject,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeTenantApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param prescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalAddPrescriberToPractice (prescriberRequestModel: PrescriberRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalCreateMainPracticeResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/addPrescriberToPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberRequestModel' is not null or undefined
        if (prescriberRequestModel === null || prescriberRequestModel === undefined) {
            throw new Error('Required parameter prescriberRequestModel was null or undefined when calling healthCarePracticePortalAddPrescriberToPractice.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberRequestModel, "PrescriberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalCreateMainPracticeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalCreateMainPracticeResponse");
        }
        return response;
    }
    /**
     * 
     * @param tenantHealthCarePracticePortalSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalAddSiteToPractice (tenantHealthCarePracticePortalSiteRequestModel: TenantHealthCarePracticePortalSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalGetMainPracticeResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/addSiteToPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tenantHealthCarePracticePortalSiteRequestModel' is not null or undefined
        if (tenantHealthCarePracticePortalSiteRequestModel === null || tenantHealthCarePracticePortalSiteRequestModel === undefined) {
            throw new Error('Required parameter tenantHealthCarePracticePortalSiteRequestModel was null or undefined when calling healthCarePracticePortalAddSiteToPractice.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tenantHealthCarePracticePortalSiteRequestModel, "TenantHealthCarePracticePortalSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalGetMainPracticeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalGetMainPracticeResponse");
        }
        return response;
    }
    /**
     * 
     * @param mainPracticeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalCreateMainPractice (mainPracticeRequestModel: MainPracticeRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalCreateMainPracticeResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/createMainPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'mainPracticeRequestModel' is not null or undefined
        if (mainPracticeRequestModel === null || mainPracticeRequestModel === undefined) {
            throw new Error('Required parameter mainPracticeRequestModel was null or undefined when calling healthCarePracticePortalCreateMainPractice.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(mainPracticeRequestModel, "MainPracticeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalCreateMainPracticeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalCreateMainPracticeResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalGetMainPractice (xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalGetMainPracticeResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/getMainPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalGetMainPracticeResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalGetMainPracticeResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalGetPrescribersByPracticeId (xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalGetPrescribersByPracticeIdResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/getPrescribersByPracticeId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalGetPrescribersByPracticeIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalGetPrescribersByPracticeIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalGetSitesByMainPracticeId (xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalGetSitesByMainPracticeIdResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/getSitesByMainPracticeId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalGetSitesByMainPracticeIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalGetSitesByMainPracticeIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalRemovePrescriberFromPractice (tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest: TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest, xProgramId?: string): Promise<AxiosResponse<IEntlibResponseNoData>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/removePrescriberFromPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest' is not null or undefined
        if (tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest === null || tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest === undefined) {
            throw new Error('Required parameter tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest was null or undefined when calling healthCarePracticePortalRemovePrescriberFromPractice.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest, "TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemovePrescriberFromPracticeRemovePrescriberFromPracticeRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IEntlibResponseNoData>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IEntlibResponseNoData");
        }
        return response;
    }
    /**
     * 
     * @param tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalRemoveSiteFromPractice (tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest: TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest, xProgramId?: string): Promise<AxiosResponse<IEntlibResponseNoData>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/removeSiteFromPractice';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest' is not null or undefined
        if (tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest === null || tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest === undefined) {
            throw new Error('Required parameter tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest was null or undefined when calling healthCarePracticePortalRemoveSiteFromPractice.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest, "TenantHealthCarePracticePortalHealthCarePracticePortalControllerTenantHealthCarePracticePortalRemoveSiteFromPracticeRemoveSiteFromPracticeRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<IEntlibResponseNoData>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IEntlibResponseNoData");
        }
        return response;
    }
    /**
     * 
     * @param patientsSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalSearchPatientsAcrossTenant (patientsSearchRequestModel: PatientsSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/searchPatientsAcrossTenant';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientsSearchRequestModel' is not null or undefined
        if (patientsSearchRequestModel === null || patientsSearchRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchRequestModel was null or undefined when calling healthCarePracticePortalSearchPatientsAcrossTenant.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchRequestModel, "PatientsSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientsSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async healthCarePracticePortalSearchPatientsWithinProgram (patientsSearchRequestModel: PatientsSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse>> {
        const _url_ = '/edge/tenant/HealthCarePracticePortal/searchPatientsWithinProgram';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientsSearchRequestModel' is not null or undefined
        if (patientsSearchRequestModel === null || patientsSearchRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchRequestModel was null or undefined when calling healthCarePracticePortalSearchPatientsWithinProgram.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchRequestModel, "PatientsSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantHealthCarePracticePortalSearchPatientsWithinProgramResponse");
        }
        return response;
    }
    /**
     * 
     * @param prescribersByTenantRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async prescriberPrescriberSearch (prescribersByTenantRequestModel: PrescribersByTenantRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantPrescriberObject>> {
        const _url_ = '/edge/tenant/Prescriber/prescriberSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescribersByTenantRequestModel' is not null or undefined
        if (prescribersByTenantRequestModel === null || prescribersByTenantRequestModel === undefined) {
            throw new Error('Required parameter prescribersByTenantRequestModel was null or undefined when calling prescriberPrescriberSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescribersByTenantRequestModel, "PrescribersByTenantRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantPrescriberObject>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantPrescriberObject");
        }
        return response;
    }
    /**
     * 
     * @param sitesAndPrescribersByTenantRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAndPrescriberSiteAndPrescriberSearch (sitesAndPrescribersByTenantRequestModel: SitesAndPrescribersByTenantRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantSiteAndPrescriberObject>> {
        const _url_ = '/edge/tenant/SiteAndPrescriber/siteAndPrescriberSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sitesAndPrescribersByTenantRequestModel' is not null or undefined
        if (sitesAndPrescribersByTenantRequestModel === null || sitesAndPrescribersByTenantRequestModel === undefined) {
            throw new Error('Required parameter sitesAndPrescribersByTenantRequestModel was null or undefined when calling siteAndPrescriberSiteAndPrescriberSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sitesAndPrescribersByTenantRequestModel, "SitesAndPrescribersByTenantRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantSiteAndPrescriberObject>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantSiteAndPrescriberObject");
        }
        return response;
    }
    /**
     * 
     * @param sitesByTenantRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteSiteSearch (sitesByTenantRequestModel: SitesByTenantRequestModel, xProgramId?: string): Promise<AxiosResponse<TenantSiteObject>> {
        const _url_ = '/edge/tenant/Site/siteSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sitesByTenantRequestModel' is not null or undefined
        if (sitesByTenantRequestModel === null || sitesByTenantRequestModel === undefined) {
            throw new Error('Required parameter sitesByTenantRequestModel was null or undefined when calling siteSiteSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sitesByTenantRequestModel, "SitesByTenantRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<TenantSiteObject>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "TenantSiteObject");
        }
        return response;
    }
}
